import { PlanTypes } from '../types/planTypes'

const initialState = {
  myPlans: {},
  loading: false,
  getPlansById: {},
  plans: [],
  planForm: {},
  plansInfo: {
    readEmergency: false,
  },

  deletePlanLoading: false,
  deletePlanSuccess: {},
  deletePlanErr: '',
  paymentForm: {},
  getPlanByIdLoading: false,
  createPlanLoading: false,
  createPlanSuccess: {},
  createPlanErr: '',
}

export const userPlanReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PlanTypes.GET_USER_PLANS_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case PlanTypes._UPDATE_PLAN_FORM: {
      return {
        ...state,
        planForm: {
          ...state.planForm,
          ...action.payload,
        },
      }
    }

    case PlanTypes._CLEAR_PLAN_FORM: {
      return {
        ...state,
        planForm: initialState.planForm,
      }
    }

    case PlanTypes.UPDATE_PAYMENT_FORM: {
      return {
        ...state,
        paymentForm: {
          ...state.paymentForm,
          ...action.payload,
        },
      }
    }

    case PlanTypes.CLEAR_PAYMENT_FORM: {
      return {
        ...state,
        paymentForm: initialState.paymentForm,
      }
    }

    case PlanTypes.GET_USER_PLANS_CALL:
      return {
        ...state,
        myPlans: action.payload,
        loading: false,
      }

    case PlanTypes.GET_USER_PLAN_BY_ID_REQUEST:
      return {
        ...state,
        getPlanByIdLoading: true,
      }

    case PlanTypes.GET_USER_PLAN_BY_ID:
      return {
        ...state,
        getPlanByIdLoading: false,
        getPlansById: action.payload,
      }

    case PlanTypes.CREATE_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case PlanTypes.CREATE_PLAN_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        createPlanSuccess: action.payload,
      }
    case PlanTypes.CREATE_PLAN_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}
